// Globals
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

// Components
import { StyledImportForm, StyledUploadContent, StyledContentWrapper, StyledUploadingBox } from '../Styled';
import { DocumentIcon, GhostRefreshingIcon } from '@/icons';
import { Button } from '@/ui';

// Models
import { ROUTES } from '@/models/router.model';

type TSuccessScreen = {
  selectedFile?: File;
};

const SuccessScreen = ({ selectedFile }: TSuccessScreen) => {
  const { t } = useTranslation(['products']);
  const navigate = useNavigate();

  const goToImportsList = () => navigate(ROUTES.IMPORTS_LIST);

  return (
    <StyledContentWrapper>
      <StyledImportForm>
        <StyledUploadContent>
          <DocumentIcon />
          {selectedFile?.name}
        </StyledUploadContent>
      </StyledImportForm>
      <StyledUploadingBox>
        <GhostRefreshingIcon />
        <span>{t('products_import_importing_message')}</span>
        <Button onClick={goToImportsList}>{t('products_import_go_to_table')}</Button>
      </StyledUploadingBox>
    </StyledContentWrapper>
  );
};

export default SuccessScreen;
